<div class="error">
  @switch (displayedError()) {
    @case (ErrorKind.UNAUTHORIZED) {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: {
            title: 'error.unauthorized.title',
            message: 'error.unauthorized.message',
            icon: 'content/triangle-exclamation-mark'
          }
        "></ng-container>
    }

    @case (null) {}

    @default {
      <ng-container
        *ngTemplateOutlet="
          errorTemplate;
          context: {
            title: 'error.loadingFailed.title',
            message: 'error.loadingFailed.message',
            icon: 'content/triangle-exclamation-mark'
          }
        "></ng-container>
    }
  }
</div>

<ng-template
  #errorTemplate
  let-title="title"
  let-message="message"
  let-icon="icon">

  <div class="message">

    <div class="header">

      <sd-4-5-1-icon
        color="primary"
        library="{{ iconLibrary }}"
        name="{{ icon }}"></sd-4-5-1-icon>

      <div class="sd-headline">
        {{ title | transloco }}
      </div>

    </div>

    <div class="sd-meta sd-meta--light">
      {{ message | transloco }}
    </div>

  </div>

</ng-template>
